<template>
  <section v-if="Bus && lang[3]">
    <Title :title-name="title.Bus.titleName" :title-link="title.Bus.titleLink" />
    <div class="bus">
      <div class="container" style="margin-top: 14pt">
        <p class="font-weight-bold">
          {{ lang[3].SFS_LANG_ROW_2 }}
        </p>
        <p
          v-html="replaceStr(lang[3].SFS_LANG_ROW_3, ['<airline_name>', '<drop_off_location>'], [airline.name, Bus.to_address])"
        ></p>
        <p class="mb-0">{{ lang[3].SFS_LANG_ROW_4 }}:</p>
        <p class="mb-0">{{ lang[3].SFS_LANG_ROW_5 }}: {{ moment(Bus.date_expire_time).format('DD-MM-YYYY, HH:mm') }}</p>
        <p>{{ lang[3].SFS_LANG_ROW_6 }}: {{ Bus.at_address }}</p>
        <p class="mb-0">{{ lang[3].SFS_LANG_ROW_7 }}: {{ Bus.comment }}</p>
        <p>{{ lang[3].SFS_LANG_ROW_8 }}: {{ Bus.bus_company_name }}</p>
        <p
          class="last"
          v-html="replaceStr(lang[3].SFS_LANG_ROW_9, ['<airline_name>', '<airline_name>'], [airline.name, airline.name])"
        ></p>
      </div>
      <ButtonDownloadVoucher :name-voucher="nameVoucher" :can-download="canDownload"></ButtonDownloadVoucher>
    </div>
  </section>
</template>

<script>
import ButtonDownloadVoucher from '@/components/ButtonDownloadVoucher/index'
import Title from '@/components/Title/index'
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'

export default {
  name: 'Bus',
  components: { ButtonDownloadVoucher, Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nameVoucher: 'Bus',
      canDownload: false
    }
  },
  computed: {
    ...mapGetters({
      Bus: 'Bus/Bus'
    })
  },
  watch: {
    Bus: function (newVal) {
      this.canDownload = newVal && newVal.at_address != '' ? true : false
    }
  },
  mounted() {
    this.$store.dispatch('Bus/getBus')
  },
  methods: {
    replaceStr
  }
}
</script>
